import React from 'react';
import PropTypes from 'prop-types';
import './HeadingLarge.css';

/**
 * HeadingLarge — Configurator
 *
 * Hero-level heading block with an optional subtitle (the product's BE
 * "Short Description"), editorial title, price and multi-paragraph
 * description text.
 *
 * Figma node: 3911:14671
 * Toggle props: showPrice, showDescription
 */

const HeadingLarge = ({
  subtitle,
  title = 'Title',
  titleAs: TitleTag = 'h2',
  price,
  description,
  className = '',
  ...props
}) => (
  <div className={`cfg-heading-lg ${className}`.trim()} {...props}>
    {/* Top: title + price */}
    <div className="cfg-heading-lg__top">
      {subtitle && (
        <h5 className="cfg-heading-lg__subtitle typo-h5">{subtitle}</h5>
      )}

      <TitleTag className="cfg-heading-lg__title typo-h2-editorial">{title}</TitleTag>

      {price && (
        <span className="cfg-heading-lg__price typo-body">{price}</span>
      )}
    </div>

    {/* Description */}
    {description && (
      <div className="cfg-heading-lg__description typo-body">
        {description}
      </div>
    )}
  </div>
);

HeadingLarge.propTypes = {
  /** Short description shown above the title (rendered as H5, uppercase) */
  subtitle: PropTypes.string,
  /** Heading title text (H2 editorial style) */
  title: PropTypes.string,
  /** Heading element of the title — "h1" when it names the page (product page); the look stays H2 editorial */
  titleAs: PropTypes.oneOf(['h1', 'h2', 'h3']),
  /** Price text (e.g. "499,-") */
  price: PropTypes.string,
  /** Description — string or ReactNode for multi-paragraph content */
  description: PropTypes.node,
  /** Additional CSS class */
  className: PropTypes.string,
};

export default HeadingLarge;
